// CardSection.js
import React from 'react';
import { CardNumberElement } from 'react-stripe-elements';

import styles from '../../Form/themeV3.scss';

class CardSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ready: false };
        this.handleReady = this.handleReady.bind(this);
    }

    handleReady(element) {
        this.setState({ ready: true });
        this.props.onCardElementReady(element);
    }

    render() {
        const { error, onChange, style, themeV3, disabled } = this.props;
        const { ready } = this.state;

        return (
            <div className={`col-12`}>
                <div className={`form-group form-group-xl ${error && 'is-invalid'} ${themeV3 ? styles.themeV3 : ''}`}>
                    <label>{!themeV3 && 'Card Number'}</label>
                    <div className={`${styles.inputWrapper} input-wrapper`}>
                        <CardNumberElement
                            style={style}
                            className={`${styles.formControl} form-control`}
                            onChange={onChange}
                            onReady={this.handleReady}
                            disabled={disabled || !ready}
                        />
                        {themeV3 && <label>Card Number</label>}
                        <div className="error-indicator" />
                    </div>
                    {error && <div className="invalid-feedback">{error}</div>}
                </div>
            </div>
        );
    }
}

export default CardSection;
